/**
 * Chat API Configuration (Admin)
 * Axios instance with base URL and auth token handling for the chat module.
 * Adapted from DOUBTQ CHATBOT for the main Admin frontend.
 */

import axios from "axios";

// Base Chat API URL
const CHAT_BASE_URL =
  process.env.REACT_APP_CHAT_API_URL || "http://localhost:5001";

// Create axios instance for chat
const chatApi = axios.create({
  baseURL: `${CHAT_BASE_URL}/api/admin/chat`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add admin auth token
chatApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor for error handling
chatApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Chat API auth error - token may be expired");
    }
    return Promise.reject(error);
  },
);

export default chatApi;
export { CHAT_BASE_URL };
